import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import React from 'react';
import {useAuth} from '@apps-common/auth-react';
import {useTranslation} from 'react-i18next';

import PlanetLogo from '../ui/pl-logo.jsx';

const TourDialog = ({onTourSkip, onTourStart}) => {
  const auth = useAuth();
  const {t} = useTranslation();

  return (
    <Dialog open>
      <DialogTitle variant="h5" data-qe="tour-dialog-title">
        <PlanetLogo />
        {t('tourDialog.title', 'Welcome to Planet Explorer!')}
      </DialogTitle>

      <DialogContent>
        <DialogContentText color="textPrimary">
          {t(
            'tourDialog.message',
            'See the Earth change by navigating through space and time. Discover the power of daily, global imagery.'
          )}
          {auth.user?.claims.is_trial &&
            t(
              'tourDialog.trialUserMessage',
              ' Your 14 day trial includes free access to 5,000 basemap tile views.'
            )}
        </DialogContentText>
        <DialogActions>
          <Button
            color="primary"
            onClick={onTourSkip}
            data-qe="skip-tour-button"
          >
            {t('tourDialog.skipButton', 'Skip')}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onTourStart}
            data-qe="start-tour-button"
          >
            {t('tourDialog.startTourButton', 'Start Tour')}
          </Button>
        </DialogActions>

        <DialogContentText variant="caption" sx={{marginTop: 3}}>
          {t(
            'tourDialog.disclaimer',
            'Planet imagery is generally made available for personal, non-profit or news journalism uses only under a creative commons (CC-by-NC) license. Please see the license terms associated with your account.'
          )}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

TourDialog.propTypes = {
  onTourSkip: PropTypes.func.isRequired,
  onTourStart: PropTypes.func.isRequired,
};

export default TourDialog;
